<template>
  <cl-breadcrumbs-v2>
    <cl-breadcrumbs-item
      v-for="(item, index) in items"
      :key="item.url"
      :is-link="Boolean(item.url)"
      :test-id="`breadcrumbs-item-${index}`"
    >
      <router-link
        custom
        v-slot="{ href }"
        :to="transformLink(item.url)"
        v-if="Boolean(item.url)"
      >
        <a :href="href">
          {{ item.name }}
        </a>
      </router-link>
      <div v-else>
        {{ item.name }}
      </div>
    </cl-breadcrumbs-item>
  </cl-breadcrumbs-v2>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { PageMeta } from "@/store/modules/pageMeta";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { getBreadcrumbs } from "./getBreadcrumbs";
import { BreadcrumbsItem } from "./breadcrumbs.types";

const store = useStore();
const route = useRoute();

const pageMeta = computed<PageMeta>(() => store.getters["pageMeta/pageMeta"]);
const authUser = computed(() => store.getters["authentication/authUser"]);
const selectedAccount = computed<null | {
  type_name: "System" | "MSP" | "Customer";
}>(() => store.getters["authentication/selectedAccount"]);
const selectedCustomer = computed(
  () => store.getters["authentication/selectedCustomer"],
);

const items = computed<BreadcrumbsItem[]>(() => {
  const meta = {
    customerName: pageMeta.value?.customerName,
    mspName: pageMeta.value?.mspName,
    parentPath: pageMeta.value.parentPath,
    title: pageMeta.value.title,
    routePath: route.path,
  };

  return getBreadcrumbs(meta);
});

const getRegex = (accountType: "System" | "MSP" | "Customer") => {
  switch (accountType) {
    case "System":
      return selectedCustomer.value ? /^\/system\/msp\// : /^\/system\//;
    case "MSP":
      return selectedCustomer.value ? /^\/msp\// : /^\/system\/msp\//;
    case "Customer":
      return selectedCustomer.value ? /^\/msp\// : null;
    default:
      return null;
  }
};

const transformLink = (link: string) => {
  if (!selectedAccount.value) {
    throw new Error(
      `Cannot redirect to breadcrumbs page, because selectedAccount is nullable for authUser: ${JSON.stringify(authUser.value)}`,
    );
  }

  const regex = getRegex(selectedAccount.value.type_name);

  if (regex) {
    const updatedRegex = link.replace(regex, "/");

    return updatedRegex;
  }
  return link;
};
</script>
